export default "__VITE_ASSET__BQ80hCVb__"